import React from 'react';
import {Card, Flex} from "antd";
import {BackButton} from "../../../../shared";
import style from "./NotificationListHeader.module.scss";
import {StyledCard} from "./NotificationListHeader.styled";

const NotificationListHeader = () => {
    return (
        <StyledCard >
            <Flex vertical gap={"middle"}>
                <Flex justify={"space-between"} align={"center"} gap={"middle"}>
                    <Flex gap={"small"} align={"center"}>
                        <BackButton/>
                        <span>اعلانات</span>
                    </Flex>
                    <img width={20} src={require("assets/Logo/logoPink.png")}/>
                </Flex>

            </Flex>
        </StyledCard>
    )

};

export default NotificationListHeader;